import { useMap } from "context/mapContext";
import PaletteDetails from "./PaletteDetails";
import PalettesList from "./PalettesList";

function PaletteTracking() {
  const [map] = useMap();
  const { paletteTrackingComponentMode } = map;

  return (
    <>
      {paletteTrackingComponentMode === "palettesList" && <PalettesList />}
      {paletteTrackingComponentMode === "paletteDetails" && <PaletteDetails />}
    </>
  );
}

export default PaletteTracking;
